// Base URL of the student ("child") app. A study-plan share link always
// lands on the parent app, but the recipient may actually be a student.
// The student app hosts the same /share/<token> landing, so we hand the
// visitor off there where they can sign in as a student and import the
// plan into their own account.
//
// Overridable at build time (staging / e2e) via REACT_APP_LF_CHILD_APP_URL;
// otherwise defaults to the prod student host. Mirrors the constant in
// components/StudyPlanDetailsModal.jsx, which does the same hand-off from
// the marketing homepage.
export const CHILD_APP_BASE =
    process.env.REACT_APP_LF_CHILD_APP_URL || 'https://student.learnforest.app';

// Build the student-app share-landing URL for a token. Returns the bare
// student-app base when no token is supplied so callers still get a valid
// link to send the visitor to.
export function childShareUrl(token) {
    const base = CHILD_APP_BASE.replace(/\/$/, '');
    return token ? `${base}/share/${encodeURIComponent(token)}` : base;
}
